<div class="background-logo">
	<img src="assets/metapress_logo_dark.png" alt="MetaPress" />
</div>

<ul
	ngbNav
	#nav="ngbNav"
	class="nav-pills ps-3 d-flex align-items-center bg-primary"
	[(activeId)]="currentURL"
>
	<li class="navbar-logo" style="list-style: none">
		<img src="assets/metapress_logo_navbar.png" alt="MetaPress Logo" />
	</li>
	<li ngbNavItem class="ps-3">
		<button
			ngbNavLink
			routerLink="/article-library"
			[ngbNavItem]="'/article-library'"
			[ngClass]="{
				'active-nav': currentURL === '/article-library',
				'inactive-nav': currentURL !== '/article-library',
			}"
		>
			<i class="bi bi-archive me-1"></i>
			Tiedostot
		</button>
	</li>

	<li ngbNavItem>
		<button
			ngbNavLink
			routerLink="/exports"
			[ngbNavItem]="'/exports'"
			[ngClass]="{
				'active-nav': currentURL === '/exports',
				'inactive-nav': currentURL !== '/exports',
			}"
		>
			<i *ngIf="!hasActiveBatchJobs" class="bi bi-play-circle me-1"></i>
			<!-- Show spinner when batch jobs are active -->
			<span
				*ngIf="hasActiveBatchJobs"
				class="spinner-border spinner-border-sm text-light me-2"
				role="status"
				aria-hidden="true"
			></span>
			Luodut pelit
			<!-- Show progress badge when there are any batch jobs -->
			<span
				*ngIf="getTotalBatchJobsCount() > 0"
				class="badge ms-2 bg-warning text-dark"
				[class.badge-pulse]="hasActiveBatchJobs"
				[title]="
					hasActiveBatchJobs
						? 'Taustalla luodaan pelejä (' +
							batchJobsProgressText +
							')'
						: 'Uusia taustalla luotuja pelejä'
				"
			>
				{{ batchJobsProgressText }}
			</span>
		</button>
	</li>

	<!-- <li ngbNavItem>
		<button
			ngbNavLink
			routerLink="/shared"
			[ngbNavItem]="'/shared'"
			[ngClass]="{
				'active-nav': currentURL === '/shared',
				'inactive-nav': currentURL !== '/shared',
			}"
		>
			<i class="bi bi-globe me-1"></i>
			Julkaistut
		</button>
	</li> -->
	<li
		ngbNavItem
		*ngIf="
			loginService.GetCurrentUser()?.permission == Roles.SuperAdmin ||
			loginService.GetCurrentUser()?.permission == Roles.Admin
		"
	>
		<button
			ngbNavLink
			routerLink="/admin/users"
			[ngbNavItem]="'/admin/users'"
			[ngClass]="{
				'active-nav': currentURL === '/admin/users',
				'inactive-nav': currentURL !== '/admin/users',
			}"
			(mouseenter)="onUsersTabHover()"
		>
			<i class="bi bi-people me-1"></i>
			Käyttäjät
		</button>
	</li>

	<li
		ngbNavItem
		*ngIf="loginService.GetCurrentUser()?.permission == Roles.SuperAdmin"
	>
		<button
			ngbNavLink
			routerLink="/admin/organizations"
			[ngbNavItem]="'/admin/organizations'"
			[ngClass]="{
				'active-nav': currentURL === '/admin/organizations',
				'inactive-nav': currentURL !== '/admin/organizations',
			}"
			(mouseenter)="onOrganizationsTabHover()"
		>
			<i class="bi bi-building me-1"></i>
			Organisaatiot
		</button>
	</li>

	<!-- Notification toggle button with history dropdown -->
	<li class="ms-auto d-flex align-items-center" style="list-style: none">
		<div
			ngbDropdown
			#dropdown="ngbDropdown"
			(mouseenter)="onNotificationBellHover(dropdown)"
			(mouseleave)="onNotificationBellLeave(dropdown)"
		>
			<button
				(click)="toggleNotifications()"
				class="btn d-flex align-items-center rounded-circle p-2 me-3 border-0 bg-transparent"
				style="cursor: pointer; width: 40px; height: 40px"
				ngbDropdownToggle
			>
				<i
					class="fs-5 text-white"
					[class.bi-bell]="notificationService.isContainerVisible"
					[class.bi-bell-slash]="
						!notificationService.isContainerVisible
					"
				></i>
			</button>

			<div
				ngbDropdownMenu
				class="notification-history-dropdown"
				(mouseenter)="onNotificationDropdownHover(dropdown)"
				(mouseleave)="onNotificationDropdownLeave(dropdown)"
			>
				<h6 class="dropdown-header">
					Ilmoitukset
					{{
						notificationService.isContainerVisible
							? "(päällä)"
							: "(poissa)"
					}}
				</h6>
				<div class="dropdown-divider"></div>

				<div
					*ngIf="notificationService.notificationHistory.length === 0"
					class="dropdown-item-text text-muted"
				>
					Ei ilmoituksia
				</div>

				<div
					*ngFor="
						let notification of notificationService.notificationHistory;
						trackBy: trackByNotificationId
					"
					class="notification-history-item"
				>
					<div class="d-flex align-items-start">
						<span
							class="notification-circle"
							[class.bg-primary]="
								notification.style === 'primary'
							"
							[class.bg-success]="
								notification.style === 'success'
							"
							[class.bg-danger]="notification.style === 'danger'"
							[class.bg-warning]="
								notification.style === 'warning'
							"
							[class.bg-secondary]="
								notification.style === 'secondary'
							"
						></span>
						<div class="flex-grow-1">
							<div class="notification-message">
								{{ notification.message }}
							</div>
							<small class="text-muted notification-timestamp">{{
								formatTimestamp(notification.timestamp)
							}}</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>

	<li class="d-flex align-items-center me-3" style="list-style: none">
		<div *ngIf="!loginService.IsLoggingIn">
			@let currentUser = loginService.GetCurrentUser();
			@if (currentUser) {
				<button
					(click)="open(content)"
					class="btn d-flex align-items-center bg-light rounded-pill px-3 py-1 shadow-sm border-0"
					style="cursor: pointer"
				>
					<i class="bi bi-person-fill fs-5 text-primary me-2"></i>
					<span class="fw-medium text-dark">
						{{ currentUser.firstName }}
						<!-- {{
							currentUser.lastName &&
							currentUser.lastName.length > 0
								? currentUser.lastName[0]
								: ""
						}} -->
					</span>
				</button>
			}
		</div>
	</li>
</ul>
<div
	[@routeAnimations]="getRouteAnimationData()"
	class="router-animation-wrapper"
>
	<router-outlet></router-outlet>
</div>

<ng-template #content let-offcanvas>
	<div class="offcanvas-header">
		<h4 class="offcanvas-title" id="offcanvas-basic-title">Päävalikko</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="offcanvas.dismiss('Cross click')"
		></button>
	</div>
	<div class="offcanvas-body offcanvas-nav">
		<ul
			ngbNav
			#nav="ngbNav"
			class="nav-pills"
			[(activeId)]="currentURL"
			orientation="vertical"
		>
			<!-- <li
				ngbNavItem
				*ngIf="
					loginService.GetCurrentUser()?.permission !== Roles.Admin
				"
			>
				<button
					ngbNavLink
					routerLink="/admin/users"
					[ngbNavItem]="'/admin/users'"
				>
					<i class="bi bi-people"></i>
					Käyttäjien hallinta
				</button>
			</li>

			<li
				ngbNavItem
				*ngIf="
					loginService.GetCurrentUser()?.permission !== Roles.Admin
				"
			>
				<button
					ngbNavLink
					routerLink="/admin/organizations"
					[ngbNavItem]="'/admin/organizations'"
				>
					<i class="bi bi-building"></i>
					Organisaatioiden hallinta
				</button>
			</li> -->

			<!-- <li ngbNavItem class="nav-title pt-4">YLLÄPITO</li> -->

			<li ngbNavItem class="nav-title">ASETUKSET</li>

			<li ngbNavItem>
				<button
					class="btn text-start"
					(click)="openUserProfile(); CloseOffcanvas()"
				>
					<i class="bi bi-person-lines-fill me-1"></i>
					Omat tiedot
				</button>
			</li>

			<li ngbNavItem>
				<button
					class="btn text-start"
					(click)="onManageTags(); CloseOffcanvas()"
				>
					<i class="bi bi-tags me-1"></i>
					Muokkaa tageja
				</button>
			</li>

			<li ngbNavItem>
				<button
					class="btn text-start"
					(click)="onManageStylePresets(); CloseOffcanvas()"
				>
					<i class="bi bi-stars me-1"></i>
					Tyyliasetusten hallinta...
				</button>
			</li>

			<!-- <li ngbNavItem>
				<button
					class="btn text-start"
					(click)="onManageColorPalettes(); CloseOffcanvas()"
				>
					<i class="bi bi-palette me-1"></i>
					Värien hallinta...
				</button>
			</li> -->

			<li ngbNavItem>
				<button
					class="btn text-start"
					(click)="openUpdateNotificationModal(); CloseOffcanvas()"
				>
					<i class="bi bi-info-circle me-1"></i>
					Päivitystiedot
				</button>
			</li>

			<li ngbNavItem>
				<button
					class="btn text-start"
					(click)="openPrivacyPolicyModal(); CloseOffcanvas()"
				>
					<i class="bi bi-shield-check me-1"></i>
					Tietosuojaseloste...
				</button>
			</li>

			<li ngbNavItem class="border-top mt-3 pt-3">
				<div class="ps-3 pb-3">
					<span class="d-block pb-2"> Sisällönluonnin kieli </span>
					<app-generation-language-dropdown></app-generation-language-dropdown>
				</div>
			</li>

			<li ngbNavItem class="nav-title border-top mt-3 pt-3">
				TOKEN-KULUTUS
			</li>

			<li ngbNavItem>
				<div class="ps-3 pb-3">
					<div
						*ngIf="isLoadingTokenUsage"
						class="d-flex align-items-center"
					>
						<div
							class="spinner-border spinner-border-sm text-primary me-2"
							role="status"
						>
							<span class="visually-hidden">Ladataan...</span>
						</div>
						<span class="text-muted"
							>Ladataan token-kulutusta...</span
						>
					</div>
					<div
						*ngIf="!isLoadingTokenUsage && tokenUsage !== null"
						class="d-flex flex-column"
					>
						<span class="text-muted small">Kuukauden kulutus:</span>
						<span class="fw-bold"
							>{{ tokenUsage | number: "1.0-0" }} tokenia</span
						>
					</div>
					<div
						*ngIf="!isLoadingTokenUsage && tokenUsage === null"
						class="text-muted small"
					>
						Token-kulutus ei saatavilla
					</div>
				</div>
			</li>

			<!-- <li ngbNavItem class="nav-title pt-4">YLLÄPITO</li> -->

			<!-- <li ngbNavItem>
				<button
					class="btn text-start"
					(click)="openAdvancedFeatures(advancedFeaturesModal)"
				>
					<i class="bi bi-gear me-2"></i>
					Näytä edistyneet toiminnot
				</button>
			</li> -->

			<li ngbNavItem class="border-top mt-3 pt-3">
				<button
					class="btn text-start text-danger"
					(click)="loginService.Logout(); CloseOffcanvas()"
				>
					<i class="bi bi-box-arrow-right me-1"></i>
					Kirjaudu ulos
				</button>
			</li>
		</ul>

		<div class="text-center">
			<div class="text-muted small mt-4 pt-4">
				Versio {{ settingsService.AppVersionWithPostfix }} ({{
					settingsService.AppDataVersion
				}})
			</div>
		</div>
	</div>
</ng-template>

<!-- Advanced Features Modal -->
<ng-template #advancedFeaturesModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Edistyneet toiminnot</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss()"
		></button>
	</div>
	<div class="modal-body">
		<div class="alert alert-warning" role="alert">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			<strong>Varoitus:</strong> Nämä toiminnot ovat tarkoitettu vain
			kehittäjille ja edistyneille käyttäjille. Käytä näitä toimintoja
			vain, jos tiedät mitä olet tekemässä.
		</div>

		<!-- <div class="d-grid gap-2">
			<button
				class="btn btn-outline-danger"
				(click)="DeleteAllVectorStoresAndFiles(); modal.close()"
			>
				<i class="bi bi-trash3 me-2"></i>
				Tyhjennä vektoritietokanta
			</button>
		</div> -->
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-primary btn-padding btn-color"
			(click)="modal.close()"
		>
			Sulje
		</button>
	</div>
</ng-template>
